import { makeStyles } from 'tss-react/mui';
import { colors } from 'styles/styleVariables';

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    '& .MuiContainer-root': {
      border: 'none',
    },
    '& .MuiGrid-container >  .MuiGrid-item:nth-child(1) > [class^="sc-"] ': {
      textTransform: 'uppercase',
      color: `${colors.amnDeeperBlue}`,
      fontWeight: 500,
      borderBottom: `2px solid ${colors.amnDeeperBlue}`
    },
     '& .MuiGrid-container >  .MuiGrid-item:nth-child(1) > [class^="sc-"] > [class^="sc-"] ': {
      width:'min-content'
    },
  },
  tabContainer: {
    width: '250px !important',
    marginRight: '12px',
    position: 'sticky',
    bottom: -8,
    fontWeight: 500,
    zIndex: 10,
    backgroundColor: `${colors.amnLightredGrey}`,
  },
  tab: {
    '& .MuiButton-label': {
      justifyContent: 'start',
    },
    width: '100%',
    wordBreak: 'keep-all',
    textAlign: 'start',
    margin: '10px 10px',
  },
  tabRenderContainer: {
    flex: 1,
    height: 'calc(100vh - 150px)',
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'scroll',
  },
  tabLabel: {
    padding: '10 0px 5px 5px',
    fontSize: '14px',
    fontWeight: 500,
  },
  selectedTab: {
    backgroundColor: ` ${colors.amnPurple}`,
    height: '36px',
    width: '4px',
    cursor: 'pointer',
  },
  unselectedTab: {
    height: '36px',
    width: '4px',
  },
  selectable: {
    cursor: 'pointer',
  },

  textColorSelected: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    color: '#5A4A9E',
    cursor: 'pointer',
    fontSize: '14px',
  },
  textColorUnselected: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    cursor: 'pointer',
    fontSize: '14px',
    color: '#333333',
  },
  
  subMenuTextContainer: {
    height: '36px',
    padding: '0px 6px',
    display: 'flex',
    alignItems: 'center',
  },
  centerBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  fullHeight: {
    height: '100%',
  },
  topBar: {
    marginTop: '12px',
    display: 'flex',
    width: '100%',
  },
  MuiCircularProgressRoot: {
    left: '50%',
    position: 'absolute',
    top: '50vh',
  },
  actionContainer: {
    backgroundColor: `${colors.white}`,
    '&:hover, &:focus': {
      backgroundColor: `${colors.white}`,
    },
    marginBottom: '-8px',
    position: 'fixed',
    bottom: -8,
    width: '100%',
    padding: 5,
    zIndex: 10,
  },
  headlabel: {
    fontSize: 16,
    fontWeight: 500,
    padding: '15px 10px 10px 5px',
  },
subheadlabel: {
    fontSize: 16,
    fontWeight: 500,
    padding: '15px 10px 10px 0px',
	  color: `${colors.amnDeeperBlue}`,
    borderBottom: `2px solid ${colors.amnDeeperBlue}`,
  },
  headToplabel: {
    fontSize: 17,
    fontWeight: 500,
    padding: '15px 10px 10px 5px',
  },
  labelCell: {
    fontSize: 14,
    fontWeight: 500,
    padding: 8,
  },
  dataCell: {
    fontSize: 14,
    padding: 8,
  },
  alternativeRow :{ backgroundColor: `${colors.amnLightredGrey}`},
  alternativeLabelCell: {
    fontSize: 14,
    fontWeight: 500,
    padding: 8,
    backgroundColor: `${colors.amnLightredGrey}`,
  },
  alternativeDataCell: {
    fontSize: 14,
    padding: 8,
    backgroundColor: `${colors.amnLightredGrey}`,
  },
  gridLabel: {
    fontSize: 14,
    fontWeight: 500,
    padding: 8,
  },
  gridData: {
    fontSize: 14,
    padding: 8,
    ':nth-of-type(2)': {
      boxShadow: `0px 0px 0px ${colors.amnDarkGrey}, 0px -1px 1px ${colors.amnDarkGrey}`,
    }
    ,
    ':nth-of-type(even)': {
      backgroundColor: `${colors.amnLightredGrey}`,
    }
  },
  customTable: {
    '& .MuiTableCell-sizeSmall': {
      padding: '6px 0px 6px 16px',
    },
  },

  gridrightAlign: {
    textAlign: 'right',
  },
  gridrightAlignwithpad: {
    textAlign: 'right',
    paddingRight: '5%',
  },
  gridBoxShadow: {
    boxShadow: `0px 0px 0px ${colors.amnDarkGrey}, 0px -1px 1px ${colors.amnDarkGrey}`,
  },

  
  
}));
